import dynamic, { DynamicOptions } from 'next/dynamic'
import { CollectiblesNavProps } from '@/layouts/CollectiblesLayout/CollectiblesNav/CollectiblesNav'
import { logger } from '@/utils/logging'

export const CollectiblesNav = dynamic(
  import('./CollectiblesNav')
    .then((mod) => mod.default)
    .catch((err) => logger().error(`Failed to load the Ticket Nav Bar!`, err)) as DynamicOptions<CollectiblesNavProps>,
  { ssr: false },
)
